import { useFormik } from "formik"
import React, { useContext, useState } from "react"
import { Link } from "react-router-dom"
import * as Yup from "yup"
import "../../assets/scss/custom/pages/_signup.scss";
import {
  Row,
  Col,
  Form,
  Input,
  FormFeedback,
  Label,
  Button,
} from "reactstrap"
import { forgetPassword } from "http/auth/reset";
import ToastDialog from "components/Common/ToastDialog";
import { SystemConfigurationContext } from "context/systemConfigContext";
import "./authentication.scss"

const ForgotPassword = () => {
  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const [loading, setLoading] = useState(false)
  const {inputMax} = useContext(SystemConfigurationContext)

  const validation = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Must be a valid Email")
        .max(255)
        .required("Please Enter Your Email"),
    }),
    onSubmit: values => {
      setLoading(true)
      submit(values.email)
    },
  })

  const submit = email => {
    forgetPassword({ email: email })
      .then(res => {
        setLoading(false)
        if (res.status) {
          setToastInfo({
            message: res.message,
            showToast: true,
            role: "success",
          })
          validation.resetForm()
        } else {
        setLoading(false)
          setToastInfo({
            message: res.message,
            showToast: true,
            role: "error",
          })
        }
      })
      .catch(err => {
        setLoading(false)
        console.error(err)
      })
  }

  return (
    <React.Fragment>
      <div className="account-pages bg-auth account-pages-bg">
        <>
          <Row className="justify-content-center  w-100 h-100 align-items-center w-100">
          <Col md={6}
              lg={7} xl={8} className="d-none d-md-block" style={{flex:'auto'}}>
              <div className="left-section h-100">

                <div className="d-flex justify-content-center w-100 h-100 align-items-center">
                  <img
                    className="img-fluid verification-img"
                    src={"/login5.svg"}
                    alt="Logo"
                  />
                </div>
              </div>
            </Col>
            <Col
              md={6}
              lg={5}
              xl={4}
              className="d-flex justify-content-center"
            >
              <div className="form-layout-section ms-4 ms-md-0 h-100 login-section">
                <div className="d-flex w-75 m-auto justify-content-center d-block">
                  <img
                    src={"/subros_logo.png"}
                    alt=""
                    className="img-fluid ci-logo"
                  />
                </div>
                <div
                  style={{ textAlign: "start" }}
                  className="d-flex  flex-column align-items-center"
                >
                  <p
                    style={{
                      color: "#344fa0",
                      textAlign: "center",
                      fontSize: "25px",
                      fontWeight: "500",
                    }}
                  >
                    Forgot your Password?
                  </p>
                </div>
                <div className="p-2 ">
                  <Form
                    className="needs-validation"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <div className="form-floating mb-3">
                      <Input
                      maxLength={inputMax}
                        name="email"
                        placeholder="Enter Registered Email"
                        type="email"
                        className="form-control"
                        id="forgotEmail"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          !!(
                            validation.touched.email && validation.errors.email
                          )
                        }
                        style={{ borderRadius: "1rem" }}
                      />
                      <Label htmlFor="forgotEmail">Email</Label>
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid">
                          {validation.errors.email}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="w-100 mt-3 d-flex justify-content-center">
                      <Button
                        style={{ backgroundColor: "#344fa0", border: "none" }}
                        type="submit"
                      >
                        <output>
                          {loading && (
                            <span
                              className="spinner-border spinner-border-sm ms-2 me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          )}
                        </output>
                        {!loading && <span>Send Reset Link</span>}
                        {loading && <span>Sending...</span>}
                      </Button>
                    </div>
                  </Form>
                </div>
                <div className="mt-3 text-center">
                  <p>
                    <Link
                      to="/login"
                      style={{ color: "#344fa0" }}
                      className="fw-medium"
                    >
                      {" "}
                      Back To Login{" "}
                    </Link>{" "}
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </>
      </div>

      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  )
}

export default ForgotPassword
